/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useMemo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dimensions, TouchableOpacity, View } from 'react-native';
import { Loader } from '@components/screen/Layout';
import Image from '@components/global/Image';
import ModalHalf from '@components/modal/ModalHalf';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';

import {
  takePicture,
  chooseMultipleImagePicker,
  chooseImagePicker,
} from '@global/helpers';
import { showAlert } from '@/store/global';
import Colors from '@global/colors';

// import useSqlLite from '@/hooks/useSqlLite';
import { logEvent } from '@global/analytics';

const addPhotoIcon = {
  width: 19,
  height: 16,
};

const imageSize = 100;
const imageStyle = {
  position: 'relative',
  width: imageSize,
  height: imageSize,
  borderRadius: 4,
  overflow: 'hidden',
};
const imageAddStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f7f7f7',
};
const imageDisabled = {
  opacity: 0.2,
};

const dimension = Dimensions.get('screen');

// eslint-disable-next-line react/prop-types
const AddImage = ({
  data = [],
  setData = () => {},
  disabled = false,
  loadingCallback,
  additional = {},
}) => {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [showImageOptions, setShowImageOptions] = useState(false);

  const processImage = (image) => {
    if (image && image.uri) {
      setUploading(false);
      if (loadingCallback) {
        loadingCallback(false);
      }
      setData(JSON.parse(JSON.stringify(image)));
    }
  };

  const addImage = async (source = 'camera') => {
    setShowImageOptions(false);
    if (!disabled && !uploading) {
      logEvent({
        eventName: 'upload_image',
        data: {
          activity_id: additional?.activity?._id,
          task_id: additional?.task?._id,
        },
        dataKey: 'detail',
      });
      setUploading(true);
      if (source === 'camera') {
        const image = await takePicture(350);
        processImage(image);
      } else {
        if (additional?.isMultipleImage) {
          const images = await chooseMultipleImagePicker(350);
          if (images) {
            // Check for limit if exists
            if (additional?.limit) {
              const total = data.length + images.length;
              if (total > additional.limit) {
                setUploading(false);
                dispatch(
                  showAlert({
                    show: true,
                    isModal: true,
                    title: 'Error',
                    description: `Maksimal foto yang diupload hanya ${additional.limit}`,
                    isConfirm: false,
                    testID: 'todo-image-add-limit',
                  }),
                );
                return;
              }
            }
            for (const image of images) {
              processImage(image);
            }
          }
        } else {
          const image = await chooseImagePicker(350);
          processImage(image);
        }
      }
      setUploading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted && loadingCallback) {
      loadingCallback(uploading);
    }
    return () => {
      mounted = false;
    };
  }, [uploading]);

  const ResultImage = useMemo(() => {
    return uploading ? (
      <Loader />
    ) : (
      <Image
        style={addPhotoIcon}
        width={addPhotoIcon.width}
        height={addPhotoIcon.height}
        svg={true}
        source={require('@assets/img/icons/add-photo.svg')}
      />
    );
  }, [uploading, addPhotoIcon]);

  const addOptions = async () => {
    setShowImageOptions(true);
  };

  const handleOnPress = async () => {
    if (uploading || disabled) {
      return false;
    }
    if (additional?.showImageOption) {
      addOptions();
    } else {
      await addImage('camera');
    }
  };

  return (
    <>
      <TouchableOpacity
        testID="todo-image-add-btn"
        onPress={handleOnPress}
        activeOpacity={0.6}
        style={[imageStyle, imageAddStyle, disabled ? imageDisabled : {}]}>
        {ResultImage}
      </TouchableOpacity>

      {additional?.showImageOption && (
        <ModalHalf
          testID="todo-image-options-modal"
          title=""
          visible={showImageOptions}
          maxWidth="100%"
          spaceFromTop={false}
          onClose={() => setShowImageOptions(false)}>
          <View style={{ width: '100%' }}>
            <View
              style={{
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Button
                testID="todo-image-take-photo-btn"
                type="grey"
                rounded={true}
                buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.blue10,
                    }}>
                    Take photo
                  </SociollaText>
                }
                onPress={async () => await addImage('camera')}
              />
              <Button
                testID="todo-image-choose-photo-btn"
                type="grey"
                rounded={true}
                buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.blue10,
                    }}>
                    Choose photo
                  </SociollaText>
                }
                onPress={async () => await addImage('gallery')}
              />
            </View>
            <View
              style={{
                width: '100%',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 15,
                paddingTop: 15,
                borderTopColor: Colors.grey0,
                borderTopWidth: 1,
              }}>
              <Button
                testID="todo-image-cancel-btn"
                type="grey"
                rounded={true}
                buttonStyle={{ width: dimension.width - 40 }}
                disabledStyle={{ width: dimension.width - 40 }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.red1,
                    }}>
                    Cancel
                  </SociollaText>
                }
                onPress={() => setShowImageOptions(false)}
              />
            </View>
          </View>
        </ModalHalf>
      )}
    </>
  );
};

export default React.memo(AddImage, (prev, next) => prev == next);
